import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { store } from './store';
import './styles/index.scss';
import reportWebVitals from './reportWebVitals';

// i18n yapılandırmasını içe aktarıyoruz
import './i18n';
import { LanguageProvider } from './i18n/LanguageContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <LanguageProvider>
      <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      </Provider>
    </LanguageProvider>
  </React.StrictMode>
);

reportWebVitals();